import styled from '@emotion/styled'
import { useState } from 'react'

const OrderImageView = styled.div`
  width: 4.5rem;
  height: 4.5rem;
  flex-shrink: 0;
  margin-right: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: ${(props) => props.theme.border.radiusSmall};
  box-shadow: ${(props) => props.theme.boxShadow.outer};

  img {
    height: 4.5rem;
    width: auto;
    max-width: none;
  }

  p {
    font-size: 1rem;
    text-align: center;
    padding: 0 0.3rem;
  }
`

const OrderImage = ({
  imageUrl,
  title,
}: {
  imageUrl?: string
  title?: string
}) => {
  const [hasError, setHasError] = useState(false)

  return (
    <OrderImageView>
      {!imageUrl || hasError ? (
        <p>Image failed to load</p>
      ) : (
        <img
          src={imageUrl}
          title={title}
          alt={title}
          onError={() => setHasError(true)}
        />
      )}
    </OrderImageView>
  )
}

export default OrderImage
